import type { ReactElement } from "react";

import { useApiData } from "../../api/use-api-data.js";
import { usePageMeta } from "../../app/use-page-meta.js";

import { ConfirmPage } from "./confirm-page.js";
import { DataPending } from "./data-pending.js";
import { tenantUserUrls } from "./urls.js";

/** 削除の確認（<c>GET /api/tenants/{契約}/users/delete</c>。サーバの TenantUserDeleteViewModel と同じ欄）。 */
export interface TenantUserDelete {
    readonly tenantId: number;
    readonly email: string;
    readonly userName: string;
    readonly confirmText: string;
}

/**
 * 最後の確認はブラウザの確認ダイアログで行う（重要な操作は最後にダイアログで確かめる。2026-10-10 に利用者が決めた）。
 */
export const deleteDialog = (name: string, email: string): string =>
    `「${name}（${email}）」をこの契約から削除します。この操作は元に戻せません。よろしいですか？`;

/**
 * 利用者の削除。<b>削除した後の行き先はサーバが決める</b>（自分を削除したら契約一覧）。
 */
export function UserDeletePage({ tenantId, id }: {
    readonly tenantId: number;
    readonly id: string;
}): ReactElement {
    usePageMeta("利用者の削除");
    const data = useApiData<TenantUserDelete>(tenantUserUrls.api.delete(tenantId, id));

    if (data.state !== "ready") {
        return <DataPending data={data} />;
    }

    const user = data.value;
    return (
        <ConfirmPage
            title="利用者の削除"
            lead={`${user.userName}（${user.email}）`}
            confirmText={user.confirmText}
            action={tenantUserUrls.api.delete(user.tenantId, user.email)}
            cancel={tenantUserUrls.index(user.tenantId)}
            submit={{ label: "削除する", className: "btn-danger" }}
            dialog={deleteDialog(user.userName, user.email)}
        />
    );
}
